export const subscription = user_id => `subscription{
	notificationUser(user_id:"${user_id}"){
	  notification_title
	  notification_type
	  notification_body
	  date_time
	  notification_id
	  user_id
	  from
	  seen
	}
  }`
